'use client'

import { useMemo } from 'react'
import { compact, maxBy } from 'lodash'

import { CatalogNavigationModel } from '@marketplace-web/catalog/catalog-data'
import { useCatalogContext } from '@marketplace-web/catalog/catalog-page-data'

const useGetCatalogForBreadcrumbs = (): Array<CatalogNavigationModel> => {
  const { state } = useCatalogContext()

  const contextBreadcrumbs = useMemo(() => {
    const catalogs = state.data?.catalogs
    const selectedCatalogIds = state.filters?.catalogIds

    if (!catalogs || !selectedCatalogIds) return []

    const selectedCatalogs = compact(
      selectedCatalogIds.map(catalogId => catalogs.find(catalog => catalog.id === catalogId)),
    )

    const deepestCatalog = maxBy(selectedCatalogs, catalog => catalog.depth)

    if (!deepestCatalog) return []

    let catalog: CatalogNavigationModel | undefined = deepestCatalog
    const result: Array<CatalogNavigationModel> = []

    while (catalog) {
      result.push(catalog)

      const { parentId } = catalog
      catalog = catalogs.find(cat => cat.id === parentId)
    }

    return result.reverse()
  }, [state])

  return contextBreadcrumbs
}

export default useGetCatalogForBreadcrumbs
